import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {connect, useDispatch} from 'react-redux';
import { Row, Col, Input } from 'reactstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useParams} from "react-router-dom";
import Axios from 'axios';
import shortid from 'shortid';

import {
    ConsultaAPI,
    VinculosAPI,
    AcervoAPI,
} from '../../../../shared/http-requests';
import { upper, Permissao } from '../../../../shared/helpers';
import { clearSubmenuSelected } from "../../../../store/ducks/dadosAcervo";
import Detalhes from "../../components/DadosAcervo/Detalhes";
import { usePrefiterParams } from '../../../../shared/hooks';

const SecaoComentarios = React.lazy(() =>
    import('../../components/DadosAcervo/SecaoComentarios'),
);
const DadosAcervoCapa = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoCapa'),
);
const DadosAcervoMarc = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoMarc'),
);
const DadosAcervoHeader = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoHeader'),
);
const DadosAcervoReferencia = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoReferencia'),
);
const DadosAcervoPrincipal = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoPrincipal'),
);
const DadosAcervoExemplares = React.lazy(() =>
    import('../../components/DadosAcervo/v2/DadosAcervoExemplares'),
);
const DadosAcervoDublinCore = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoDublinCore'),
);
const DadosAcervoReserva = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoReserva'),
);
const LinksDadosAcervo = React.lazy(() =>
    import('../../components/DadosAcervo/LinksDadosAcervo'),
);
const DadosAcervoSolicitacaoEmprestimo = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoSolicitacaoEmprestimo'),
);

const Kardex = React.lazy( () => import("../../pages/acervo/Kardex"));

const Sumarios = React.lazy( () => import("../../pages/acervo/Sumarios"));

const DadosEstatisticos = React.lazy( () => import("../../pages/acervo/DadosEstatisticos"));


const OtherEditions = React.lazy(() =>
    import('../../components/v2/OtherEditions'),
);

const COD_ATIVIDADE_REFERENCIA = '33';
const COD_ATIVIDADE_MARC = '36';
const COD_ATIVIDADE_EXEMPLARES = '30';
const COD_ATIVIDADE_DUBLIN_CORE = '115';
const COD_ATIVIDADE_RESERVA = '18';
const COD_ATIVIDADE_SOLICITACAO_EMPRESTIMO = '75';
const COD_ATIVIDADE_COLECAO_KARDEX = '32';
const COD_ATIVIDADE_SUMARIOS = 'summary';
const COD_ATIVIDADE_SUMARIO_LIVRO = 'sumario_livro';
const COD_ATIVIDADE_DADOS_ESTATISTICOS = '74';
const SUB_MENU_DETALHES = 'detalhes';

const enderecosLinks = {
    '-1': 'capas',
    0: '',
    30: 'exemplares',
    33: 'referencia',
    36: 'marc',
    32: "colecao-kardex",
    'summary': "sumarios",
    18: 'reserva',
    31: 'localizacao',
    75: 'solicitacao-emprestimo',
    115: 'dublin-core',
    'sumario_livro': 'sumarios-livros',
    74: 'dados-estatisticos'
};

const DadosAcervoCompleto = ({
    statusRx,
    consultaRx,
    atividadesRx,
    pagePrefix,
    linkCurrent,
    ultimoLogRx,
    history,
    location,
    subMenuSelected,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const params = useParams();
    //? Codigo do acervo vindo pela rota:
    const { codAcervo, codBiblioteca } = params;
    //? Link disponíveis na div esquerda da página:
    const [links, setLinks] = useState(false);
    //? Link atual selecionado pelo usuário:
    const [linkAtual, mudarLinkAtual] = useState(null);
    //? Array com os códigos das permissoes
    const [permissoes, setPermissoes] = useState([33, 36, 115]);
    //? Dados do acervo (principal)
    const [dadosAcervo, setDadosAcervo] = useState(false);
    //? Coleção de imagens das capas vindas do banco:
    const [imagesCarousel, insertImagesCarousel] = useState(false);
    //? Referência vinda do banco:
    const [referenciaAcervo, insertReferenciaAcervo] = useState(false);
    //? MARC vindo do banco:
    const [marcAcervo, insertMarcAcervo] = useState(false);
    //? Dublin core
    const [dublinCore, setDublinCore] = useState(false);
    const [exemplaryData, setExemplaryData] = useState();
    const [exemplaryDataError, setExemplaryDataError] = useState(false);
    const [acervoLinks, setAcervoLinks] = useState([]);
    const [acervoAtual, setAcervoAtual] = useState(null);
    const { getAll} = usePrefiterParams();

    //Quando mudar o cod acervo da URL, reseta os dados da tela
    useEffect(() => {
        mudarLinkAtual(null);

        if (permissoes.some(p => ![33, 36, 115].includes(p)))
            setPermissoes([33, 36, 115]);

        setDadosAcervo(false);
        insertMarcAcervo(false);
        insertReferenciaAcervo(false);
        insertImagesCarousel(false);
        setDublinCore(false);
        setExemplaryData(undefined);
        setExemplaryDataError(false);
        setAcervoLinks([]);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codAcervo]);

    // Carrega os links do menu esquerdo
    useEffect(() => {
        if (atividadesRx.length) {
            let collection = [
                ...atividadesRx
                    .filter(atividade =>
                        permissoes.includes(parseInt(atividade.cod_atividade, 10)),
                    )
                    .map(atividade => {
                        let tempDesc = atividade.descricao
                            .split('-')
                            .pop()
                            .trim();

                        if (
                            atividade.cod_atividade === '30' && exemplaryData?.geraExemplar === 'B' && exemplaryData?.data?.length > 0
                        ) tempDesc = 'Bibliotecas';

                        if(atividade.cod_atividade === '32')
                            tempDesc = t('ColecaoKardex')

                        if(atividade.cod_atividade === '74')
                            tempDesc = t('DadosEstatisticos')

                        return {
                            cod_atividade: atividade.cod_atividade,
                            link: enderecosLinks[atividade.cod_atividade] || '',
                            descricao: tempDesc,
                        };
                    }),
                { cod_atividade: '0', descricao: t('DadosAcervo'), link: '' },
                { cod_atividade: '-1', descricao: t('Capas') },
            ];

            collection = collection.sort((a, b) =>
                parseInt(a.cod_atividade, 10) < parseInt(b.cod_atividade, 10)
                    ? -1
                    : 1,
            )

            /**
             * Verificando permissão
             * Adicionando item de menu 'Sumários' após o item 'Coleção Kardex'
             */
            if(permissoes.includes(COD_ATIVIDADE_SUMARIOS)){
                collection.push({cod_atividade: 'summary',
                    descricao: t('Sumarios'),
                    link: enderecosLinks[COD_ATIVIDADE_SUMARIOS]});
            }

            if(permissoes.includes(COD_ATIVIDADE_SUMARIO_LIVRO)){
                collection.push({cod_atividade: 'sumario_livro',
                    descricao: t('SumariosOuDocumentosOnline'),
                    link: enderecosLinks[COD_ATIVIDADE_SUMARIO_LIVRO]});
            }

            /**
             * Só leva em consideração a permissão 74, sem verificar nas atividades
             */
            const hasAddedDadosEstatisticos = collection.some(l => l.cod_atividade === COD_ATIVIDADE_DADOS_ESTATISTICOS);
            if(!hasAddedDadosEstatisticos && permissoes.includes(parseInt(COD_ATIVIDADE_DADOS_ESTATISTICOS, 10))) {
                collection.push({ cod_atividade: '74', descricao: t('DadosEstatisticos'), link: '' })
            }



            setLinks(collection);
        }
    }, [atividadesRx, permissoes, t]);

    // Inicializa página com o link atual com base na propriedade passada pelo router.
    useEffect(() => {
        if (!linkAtual && links) {
            const codAtividade = linkCurrent || '0';
            mudarLinkAtual(
                links.filter(link => link.cod_atividade === codAtividade)[0],
            );
        }
    }, [linkAtual, links, linkCurrent]);

    // Caso o usuário tenha vindo pela url, efetua uma pesquisa automática para efeitos de estatística:
    useEffect(() => {
        if (!consultaRx && statusRx) {
            ConsultaAPI.consulta({
                termo_pesquisa: codAcervo,
                coluna_um: 'INDICE_30',
                search_id: shortid.generate(),
                search_tab: 'pesquisa_geral',
            })
                .then((response) => {
                    const {data} = response;
                    if(data) setAcervoAtual(data[0])
                })
                .catch(error => {
                    console.error(error);
                });
        }else if(consultaRx){
            const {data} = consultaRx;
            if(data) setAcervoAtual(data[0])
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consultaRx, statusRx]);

    // Buscar dados do acervo (principal)
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (statusRx && !dadosAcervo) {
            AcervoAPI.buscarDadosAcervo(codAcervo, cancelToken.token)
                .then(response => {
                    setDadosAcervo(response.data);
                })
                .catch(error => {
                    if (!Axios.isCancel(error))
                        setDadosAcervo({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, statusRx, dadosAcervo]);

    // Pegar a coleção das imagens, caso ainda não tenha feito:
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (statusRx) {
            VinculosAPI.buscarImagensAcervo(codAcervo, 0, cancelToken.token)
                .then(response => insertImagesCarousel(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        insertImagesCarousel({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, statusRx]);

    // Pegar a coleção das imagens, caso ainda não tenha feito:
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (statusRx) {
            AcervoAPI.buscarLinks(codAcervo, cancelToken.token)
                .then(response => setAcervoLinks(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error)) console.error(error);
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, statusRx]);

    // Buscar referência do acervo
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (
            atividadesRx.length &&
            (Permissao.tem(parseInt(COD_ATIVIDADE_REFERENCIA, 10)) ||
                permissoes.some(p => p === 18) ||
                permissoes.some(p => p === 75)) &&
            statusRx &&
            !referenciaAcervo
        ) {
            AcervoAPI.buscarReferenciaAcervo(codAcervo, cancelToken.token)
                .then(response => insertReferenciaAcervo(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        insertReferenciaAcervo({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codAcervo, statusRx, atividadesRx, permissoes]);

    // Buscar MARC
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (
            atividadesRx.length &&
            Permissao.tem(parseInt(COD_ATIVIDADE_MARC, 10)) &&
            statusRx
        ) {
            AcervoAPI.buscarMarcAcervo(codAcervo, false, cancelToken.token)
                .then(response => insertMarcAcervo(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        insertMarcAcervo({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, statusRx, atividadesRx]);

    //Busca dados dos exemplares
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
         if (
            !atividadesRx.length ||
            !Permissao.tem(parseInt(COD_ATIVIDADE_EXEMPLARES, 10)) &&
            !statusRx
        ) return;
         const { id: campusName, id_biblioteca } = getAll();

        AcervoAPI.buscaExemplares(codAcervo, id_biblioteca, campusName, cancelToken.token)
                .then(response => {
                    setExemplaryData(response.data)
                    //Se trouxe dados adiciona a permissão para exibir o link no menu
                    if(response.data?.data?.length > 0){
                        setPermissoes(p => [...p, 30]);
                    }
                }).catch((error) => {
                    if(!Axios.isCancel(error)){
                        console.log(error)
                        setExemplaryDataError(true)
                    }
                })
        return () => {
            cancelToken.cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codAcervo, statusRx, atividadesRx]);

    //Busca os dados do dublin core
    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (
            atividadesRx.length &&
            Permissao.tem(parseInt(COD_ATIVIDADE_DUBLIN_CORE, 10)) &&
            statusRx
        ) {
            AcervoAPI.buscarDublinCoreAcervo(codAcervo, cancelToken.token)
                .then(response => setDublinCore(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        setDublinCore({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, statusRx, atividadesRx]);

    /**
     * Busca as permissões todas de uma vez
     */
    useEffect( () => {
        const cancelToken = Axios.CancelToken.source();
        AcervoAPI.buscarPermissoesMenuDadosAcervo(codAcervo, cancelToken.token)
            .then(response => {
                if (response.data) {
                    setPermissoes(p => [...p, ...response.data])
                };
            })
            .catch(error => {
                if (!Axios.isCancel(error)) console.error(error);
            });
    }, [])

    useEffect(() => {
        dispatch(clearSubmenuSelected())
    }, [linkAtual]);

    const getContent = () => {
        if (linkAtual) {
            switch (linkAtual.cod_atividade) {
                case '0':
                    if(subMenuSelected.parent === linkAtual.cod_atividade){
                        switch (subMenuSelected.submenu){
                            case SUB_MENU_DETALHES:
                                return <Detalhes />
                            default:
                                return null;
                        }
                    }

                    return (
                        <DadosAcervoPrincipal
                            dados={dadosAcervo}
                            codAcervo={codAcervo}
                        />
                    );
                case '-1':
                    return <DadosAcervoCapa images={imagesCarousel} />;
                case COD_ATIVIDADE_REFERENCIA:
                    return (
                        <DadosAcervoReferencia referencia={referenciaAcervo} />
                    );
                case COD_ATIVIDADE_MARC:
                    return <DadosAcervoMarc marc={marcAcervo} />;
                case COD_ATIVIDADE_EXEMPLARES:
                    return (
                        <DadosAcervoExemplares
                            acervo={dadosAcervo}
                            referencia={referenciaAcervo}
                            exemplaryData={exemplaryData}
                            hasError={exemplaryDataError}
                        />
                    );
                case COD_ATIVIDADE_DUBLIN_CORE:
                    return <DadosAcervoDublinCore dublinCore={dublinCore} />;
                case COD_ATIVIDADE_RESERVA:
                    return (
                        <DadosAcervoReserva
                            codAcervo={codAcervo}
                            referencia={referenciaAcervo[0]}
                        />
                    );
                case COD_ATIVIDADE_SOLICITACAO_EMPRESTIMO:
                    return (
                        <DadosAcervoSolicitacaoEmprestimo
                            codAcervo={codAcervo}
                            referencia={referenciaAcervo[0]}
                        />
                    );
                case COD_ATIVIDADE_COLECAO_KARDEX:
                    return (
                        <Kardex acervo={acervoAtual}/>
                    )
                case COD_ATIVIDADE_SUMARIOS:
                case COD_ATIVIDADE_SUMARIO_LIVRO:
                    return (
                        <Sumarios acervo={acervoAtual} tipo={linkAtual.cod_atividade} />
                    )
                case COD_ATIVIDADE_DADOS_ESTATISTICOS:
                    return (
                        <DadosEstatisticos acervo={acervoAtual} />
                    )
                default:
                    return false;
            }
        }
    };

    const handleSelectDadosAcervo = e => {
        mudarLinkAtual(links.find(l => l.cod_atividade === e.target.value));
        history.push(
            `catalogos/${pagePrefix}/acervo/${codAcervo}/${enderecosLinks[e.target.value]}`,
        );
        
        // Scroll automático para o conteúdo após mudança de seção
        setTimeout(() => {
            const consultaContent = document.querySelector('.consultaContent');
            if (consultaContent) {
                consultaContent.scrollIntoView({
                    block: 'start',
                    inline: 'nearest',
                    behavior: 'smooth',
                });
            }
        }, 300);
    };

    return (
            <div className="consultaContent col-md-12 pad5">
                <Row className="bkbranco pad5 rad5 b-w2 b-tema10 b-solid">
                    <Col md="12" xs="12">
                        <DadosAcervoHeader
                            className="b-dotted-bottom"
                            consulta={consultaRx?.data}
                            codAcervo={codAcervo}
                            ultimoLogRx={ultimoLogRx}
                            location={location}
                            goBackAcervoKids
                        />
                    </Col>
                    <Col md="12" xs="12">
                        <Row className="pt-3 pb-3 w-100">
                            <Col xs="12" md="3">
                                <LinksDadosAcervo
                                    customUrl={`/catalogos/${pagePrefix}/acervo/{codAcervo}/${codBiblioteca}/{link}`}
                                    codAcervo={codAcervo}
                                    links={links}
                                    linkAtual={linkAtual}
                                    mudarLinkAtual={mudarLinkAtual}
                                    capas={imagesCarousel}
                                    acervoCompletoKids
                                />
                            </Col>
                            <Col
                                xs="12"
                                md="9"
                                className="pr-0 pl-0 border-left b-w1 b-tema50 mt-md-0 mt-3"
                            >
                                {linkAtual && (
                                    <Row className="b-solid-bottom b-w2 b-tema50 animated fadeIn">
                                        <Col md="8" xs="12" className="p-2">
                                            <h5 className="cortxt l20 align-center">

                                                {dadosAcervo &&
                                                !dadosAcervo.error
                                                    ? `${upper(
                                                        t(
                                                            linkAtual.descricao,
                                                        ),
                                                    ) 
                                                    } - ${dadosAcervo.tipo_obra}`
                                                    : upper(
                                                        linkAtual.descricao,
                                                    )}
                                                {
                                                    subMenuSelected.submenu !== null && (
                                                        <>
                                                            <FontAwesomeIcon
                                                                icon="chevron-right"
                                                                className="s-13 mr-3 ml-3 cortxt corAlto1"
                                                            />
                                                            <span >{subMenuSelected.name}</span>
                                                        </>
                                                    )
                                                }
                                            </h5>
                                        </Col>
                                        {['0', '36', '115'].includes(
                                            linkAtual.cod_atividade,
                                        ) && subMenuSelected == null && (
                                            <Col
                                                md="4"
                                                xs="12"
                                                className="pb-2 pl-4 pr-4"
                                            >
                                                <Input
                                                    type="select"
                                                    className="b-tema20 preto70 s14"
                                                    value={
                                                        linkAtual.cod_atividade
                                                    }
                                                    onChange={e =>
                                                        handleSelectDadosAcervo(
                                                            e,
                                                        )
                                                    }
                                                >
                                                    <option value="0">{`${t(
                                                        'Exibicao',
                                                    )} -  ${t(
                                                        'Padrao',
                                                    )}`}</option>
                                                    {Permissao.tem(36) && (
                                                        <option value="36">{`${t(
                                                            'Exibicao',
                                                        )} - MARC`}</option>
                                                    )}
                                                    {Permissao.tem(115) && (
                                                        <option value="115">{`${t(
                                                            'Exibicao',
                                                        )} - Dublin Core`}</option>
                                                    )}
                                                </Input>
                                            </Col>
                                        )}
                                    </Row>
                                )}
                                <div>{getContent()}</div>
                            </Col>
                        </Row>
                    </Col>
                    {
                        acervoLinks ? (
                            <Col md={12}>
                                <OtherEditions links={acervoLinks} />
                            </Col>
                        ) : ''
                    }
                    <Col md="12" xs="12">
                        <DadosAcervoHeader
                            className="b-dotted-top"
                            consulta={consultaRx?.data}
                            codAcervo={codAcervo}
                            ultimoLogRx={ultimoLogRx}
                            location={location}
                            goBackAcervoKids
                        />
                    </Col>
                    {Permissao.tem(85) && (
                        <SecaoComentarios
                            codAcervo={codAcervo}
                            dadosAcervo={dadosAcervo}
                        />
                    )}
                </Row>
            </div>
    );
};

const mapStateToProps = state => ({
    ultimoLogRx: state.pesquisa.log[state.pesquisa.log.length - 1],
    consultaRx: state.pesquisa.consulta,
    atividadesRx: state.pageConfig.atividades,
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    autoridades: state.dadosAcervo.autoridades,
    subMenuSelected: state.dadosAcervo.subMenuSelected,
    pagePrefix: state.pergamumKids.pagePrefix
});

export default connect(mapStateToProps)(DadosAcervoCompleto);
